import React, { useState, useEffect } from "react";
import api, { url } from "../../../api/api";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { toast } from "react-toastify";

const BusinessSearchNDetails = ({ setCmpId }) => {
  // const [search, setSearch] = useState("");s
  const [searchData, setSearchData] = useState([]);
  // const [items, setItems] = useState([]);
  const [results, setResults] = useState({});

  

  useEffect(() => {
    api
        .get(`services/company/`)
        .then((response) => {
          // console.log(response.data)
          setSearchData(response.data.map(({company_name:name, id})=>({name, id})));
          // console.log(response.data[0].id)
          // setCmpId(response.data[0].id);
        })
        .catch((error) => {
          console.log(error);
        });
  }, [])




  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results)
  }

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result)
  }

  const handleOnSelect = (item) => {
    // the item selected
    // console.log(item)
    api
    .get(`/services/company/${item.id}/`)
    .then((response) => {
      // console.log("Result",response.data)
      setCmpId(response.data.id)
    
      setResults(response.data)  
    })
    .catch((error) => {
      toast.error("something went wrong")
    });

    
  }

  const handleOnFocus = () => {
    // console.log('Focused')
  }


  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
      </>
    )
  }



  return (

    <>
    <div className="mb-3 md:w-[400px] w-[250px]" >
          <ReactSearchAutocomplete
            items={searchData}
            onSearch={handleOnSearch}
            onHover={handleOnHover}
            onSelect={handleOnSelect}
            onFocus={handleOnFocus}
            autoFocus
            formatResult={formatResult}
            placeholder="Search Company"
          />
          </div>
    <div className="flex-col border-2 font-Laila border-primary-blue flex md:flex-row text-sm   ">

      
      <div className="flex   text-sm item-center md:border-r border-primary-blue">
        <p className="text-primary-red px-2  flex items-center font-bold text-base">
          ठेगाना:
        </p>
        <input
          className=" outline-none text-primary-blue"
          type=""
          placeholder=""
          value={results.company_address}
        />
      </div>
      <div className="flex flex-wrap w-fit md:border-r  text-sm  border-primary-blue">
        <p className="text-primary-red px-2  flex items-center font-bold text-base">
          स. ब्यक्तिको नाम:
        </p>
        <input
          className=" outline-none  text-primary-blue w-[100px] md:w-[120px]"
          type="text"
          placeholder=""
          value={results.company_name}
        />
      </div>
      <div className="flex flex-wrap w-fit border-r  text-sm  border-primary-blue">
        <p className="text-primary-red px-2  flex items-center font-bold text-base">
          सम्पर्क नं. :
        </p>
        <input
          className="text-primary-blue w-[100px] md:w-[]  outline-none"
          type="text"
          placeholder=""
        />
      </div>
      <div className="flex flex-wrap w-fit  text-sm   items-center border-primary-blue">
        <p className="text-primary-red  px-2 font-bold text-base">
          शेयर सदस्य संख्या :
        </p>
        <input
          className="py-2 outline-none w-10  text-primary-blue"
          type="text"
          placeholder=""
        />
      </div>
    </div>
    </>
  );
};

export default BusinessSearchNDetails;
